import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.933 9.917-1.591-5.735a5.705 5.705 0 0 0-11.068.288l-1.23 5.54a1.836 1.836 0 0 0 1.792 2.233h2.207a3.06 3.06 0 0 0 5.998 0h2.124a1.835 1.835 0 0 0 1.768-2.326m-6.89 3.55a1.84 1.84 0 0 1-1.724-1.224h3.447a1.84 1.84 0 0 1-1.724 1.224m5.608-2.69a.6.6 0 0 1-.49.242H1.837a.613.613 0 0 1-.598-.745L2.47 4.735a4.48 4.48 0 0 1 8.69-.227l1.592 5.735a.6.6 0 0 1-.1.534"
    }, null, -1)
  ]))]))
}
export default { render: render }